import { Component, Inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ActionState } from 'src/app/enums/action-state.enum';
import { SubscriptionRepo } from 'src/app/repositories/subscription-repo';
import { UserRepo } from 'src/app/repositories/user-repo';
import { DataAfterCloseUsersModal } from './models/dataAfterCloseUsersModal';

@Component({
    selector: 'app-modal-users',
    templateUrl: './modal-users.component.html',
    styleUrls: ['./modal-users.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalUsersComponent implements OnInit {

  // downloadFile
  backendResponseDownloadedFile: any = null;
  // uploadFile
  backendResponseUploadedFile: any = null;

  @Input()
  calledByOtherComponent = false;
  @Input()
  uid: string;

  constructor(
    private userRepo: UserRepo,
    private subsRepo: SubscriptionRepo,
    @Inject(MAT_DIALOG_DATA) public data: DataAfterCloseUsersModal) {
  }

  ngOnInit(): void {
    this.data = new DataAfterCloseUsersModal();
  }


  onUserWantsDownloadEvent(event: boolean): void {
    if (event) {
      this.downloadFile();
    }
  }

  onUserWantsUploadEvent(file: any): void {
    if (file) {
      this.uploadFile(file);
    }
  }


  downloadFile(): void {
    if (!this.calledByOtherComponent) {
      this.userRepo.exportUserDefinition().toPromise().then((response) => {
        this.backendResponseDownloadedFile = response;
      }).catch((err) => {
        this.backendResponseDownloadedFile = err;
      });
      return;
    }

    this.subsRepo.exportUserDefinitionOfSubscribe(this.uid).toPromise().then((response) => {
      this.backendResponseDownloadedFile = response;
    }).catch((err) => {
      this.backendResponseDownloadedFile = err;
    });


  }

  uploadFile(file: any): void {
    this.data.uploadFileState = ActionState.LOADING;
    if (!this.calledByOtherComponent) {
      this.userRepo.importUserDefinition(file).toPromise()
      .then((response) => {
        this.backendResponseUploadedFile = response;
        this.data.uploadFileState = ActionState.SUCCESS;
      })
      .catch((err) => {
        this.backendResponseUploadedFile = err;
        this.data.uploadFileState = ActionState.FAILED;
      });
      return;
    }

    this.subsRepo.importUserDefinitionOfSubscrition(file, this.uid).toPromise()
    .then((response) => {
      this.backendResponseUploadedFile = response;
      this.data.uploadFileState = ActionState.SUCCESS;
    })
    .catch((err) => {
      this.backendResponseUploadedFile = err;
      this.data.uploadFileState = ActionState.FAILED;
    });

  }


}
